import {bindable} from 'aurelia-framework';

export class HdfvrCustomElement {
    @bindable recorderReady;
    @bindable recordingStarted;
    @bindable recordingComplete;
    @bindable recorderPending;
    @bindable playbackStarted;
    @bindable playbackComplete;
    @bindable saveComplete;
    @bindable reportError;
    @bindable reportLogMessage;
    @bindable captureKey;
    @bindable reportTime;
    @bindable maxRecordTime;

    constructor() {
        
    }

    display() {

        this.flashvars = {
            userId: "u1",
            qualityurl: "audio_video_quality_profiles/wide/1280x720x30x90.xml",
            recorderId: "r1",
            sscode: "php",
            lstext: "Loading...",
            mrt: this.maxRecordTime,
            //authenticity_token: "",
            payload: JSON.stringify({ capture_key: this.captureKey })
        };
        this.hdfvrParams = {
            quality: "high",
            bgcolor: "#dfdfdf",
            play: "true",
            loop: "false",
            allowscriptaccess: "sameDomain",
            wmode: "transparent",
            base: "hdfvr/"
        };
        this.hdfvrAttributes = {
            name: "VideoRecorder",
            id: "VideoRecorder",
            align: "middle"
        };

        this.hdfvrSize = {
            width: 640,
            height: 360
        };
        this.bufferMsg.hidden = true;
       
        //wire up HDFVR callbacks
        window.onRecorderInit = this.onRecorderInit.bind(this);
        window.userHasCamMic = this.userHasCamMic.bind(this);

        window.onUploadDone = this.onUploadDone.bind(this);

        window.onSaveOk = this.onSaveOk.bind(this);
        window.onSaveFailed = this.onSaveFailed.bind(this);
        window.onRecorderReady = this.onRecorderReady.bind(this);
        window.onPlaybackComplete = this.onPlaybackComplete.bind(this);
        window.onRecordingStarted = this.onRecordingStarted.bind(this);
        window.onCamAccess = this.onCamAccess.bind(this);
        window.onFPSChange = this.onFPSChange.bind(this);
        window.onConnectionClosed = this.onConnectionClosed.bind(this);
        window.onConnectionStatus = this.onConnectionStatus.bind(this);
        //window.onMicActivityLevel = this.onMicActivityLevel.bind(this);

        window.getFlashPlayerType = this.getFlashPlayerType;

        //This script is used to prevent the web-cam remaining active on Internet Explorer
        window.onbeforeunload = function () {
            if (navigator.appName == 'Microsoft Internet Explorer') {
                var swf = document.getElementById('VideoRecorder');
                swf.disconnectAndRemove();
            }
        }


        this.renderRecorder();

        
    }

    record() {
        document.VideoRecorder.record();

        if(this.timeReportTimer) {
            clearTimeout(this.timeReportTimer);
            this.timeReportTimer = null;
        }
        this.timeReportTimer = setTimeout(this.getRecordTime.bind(this), 1000);
    }

    stop() {
        if(this.isPlaying()) {
            document.VideoRecorder.pause();
            this.lastPlaybackTime = document.VideoRecorder.getPlaybackTime();    
            this.playbackComplete();
        }
        else {
            document.VideoRecorder.stopVideo();
            this.recorderPending();
        }

        if(this.timeReportTimer) {
            clearTimeout(this.timeReportTimer);
            this.timeReportTimer = null;
        }
    }

    kill() {
        this.hdfvrWrapper.innerHTML = "";
        
    }

    save() {
        document.VideoRecorder.save();
    }

    uploadFile(videoFile) {
        console.log("video recorder",document.VideoRecorder);
        document.VideoRecorder.uploadFile(videoFile);
    }

    play() {
        this.bufferMsg.hidden = false;
        
        
        document.VideoRecorder.playVideo();
        this.checkIsPlaying();
        
        this.recorderPending();

    }
  
    getRecordTime() {
        var time = document.VideoRecorder.getStreamTime();
        this.reportTime({time: time});
        this.timeReportTimer = setTimeout(this.getRecordTime.bind(this), 1000);
    }


    checkIsPlaying() {
        if(this.isPlaying()) {
            this.bufferMsg.hidden = true;
            this.playbackStarted();
        }
        else {
            setTimeout(this.checkIsPlaying.bind(this), 1000);
        }
    }

    isPlaying() {
        var result = false;
        if(!this.lastPlaybackTime)
            result =  document.VideoRecorder.getPlaybackTime() > 0;
        else 
            result =  (document.VideoRecorder.getPlaybackTime() - this.lastPlaybackTime) > 2;


        return result; 
    }

    renderRecorder() {
        
        //VideoRecorder Embeding
        if (!this.isMobile()) {
            
            var hasFlash = this.hasFlash();
            var isIE = this.isIE();
            var isFirefox = this.isFirefox();

            if ((isIE && hasFlash == false) || (isFirefox && hasFlash == false)) {

                var css = document.createElement("style");
                css.type = "text/css";
                css.innerHTML = "div.getFlash{width:" + this.hdfvrSize["width"] + "px;height:" + this.hdfvrSize["height"] + "px;background-color:#363738;margin:0 auto;}div.getFlash p {text-align:center;vertical-align: middle;line-height:" + this.hdfvrSize["height"] + "px;font-family:sans-serif;font-size:14px;color:#ffffff;text-decoration:underline;}";
                document.body.appendChild(css);

                this.hdfvrWrapper.innerHTML = '<div class="getFlash"><p><a style = "color:#ffffff !important;" href="' + ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.adobe.com/go/getflashplayer" target="_blank">Flash Player is needed to display this content</a></p></div>';

            } else {

                var isIeLessThan9 = this.isIeLessThan9();

                if (isIE && isIeLessThan9) {
                    this.hdfvrWrapper.innerHTML = '<object type="application/x-shockwave-flash" name="' + this.hdfvrAttributes["name"] + '" id="' + this.hdfvrAttributes["id"] + '" align="' + this.hdfvrAttributes["align"] + '" width="' + this.hdfvrSize["width"] + '" height="' + this.hdfvrSize["height"] + '"><param name="quality" value="' + this.hdfvrParams["quality"] + '"><param name="bgcolor" value="' + this.hdfvrParams["bgcolor"] + '"><param name="play" value="' + this.hdfvrParams["play"] + '"><param name="loop" value="' + this.hdfvrParams["loop"] + '"><param name="allowscriptaccess" value="' + this.hdfvrParams["allowscriptaccess"] + '"><param name="wmode" value="' + this.hdfvrParams["wmode"] + '"><param name="base" value="' + this.hdfvrParams["base"] + '"><param name="flashvars" value="' + this.getFlashVarsString() + '"><param name="movie" value="hdfvr/VideoRecorder.swf"</object> ';
                } else {
                    this.hdfvrWrapper.innerHTML = '<object type="application/x-shockwave-flash" name="' + this.hdfvrAttributes["name"] + '" id="' + this.hdfvrAttributes["id"] + '" align="' + this.hdfvrAttributes["align"] + '" data="hdfvr/VideoRecorder.swf" width="' + this.hdfvrSize["width"] + '" height="' + this.hdfvrSize["height"] + '"><param name="quality" value="' + this.hdfvrParams["quality"] + '"> <param name="bgcolor" value="' + this.hdfvrParams["bgcolor"] + '"><param name="play" value="' + this.hdfvrParams["play"] + '"><param name="loop" value="' + this.hdfvrParams["loop"] + '"><param name="allowscriptaccess" value="' + this.hdfvrParams["allowscriptaccess"] + '"><param name="wmode" value="' + this.hdfvrParams["wmode"] + '"><param name="base" value="' + this.hdfvrParams["base"] + '"><param name="flashvars" value="' + this.getFlashVarsString() + '"></object> ';
                }
            }
        }
    }


    // Detecting if Flash Player is of the PPAPI variety used by Chrome and Opera 
    getFlashPlayerType() {
        console.log("getFlashPlayerType()");
        var isPPAPI = false;
        var type = 'application/x-shockwave-flash';
        var mimeTypes = navigator.mimeTypes;

        if (mimeTypes && mimeTypes[type] && mimeTypes[type].enabledPlugin && (mimeTypes[type].enabledPlugin.filename.match(/pepflashplayer|Pepper/gi))) {
            isPPAPI = true;
        }

        return isPPAPI;
    }

    isIE() {
        return /*@cc_on!@*/false || !!document.documentMode;
    }

    isIeLessThan9() {
        //Detecting IE less than version 9
        var div = document.createElement("div");
        div.innerHTML = "<!--[if lt IE 9]><i></i><![endif]-->";
        var isIeLessThan9 = (div.getElementsByTagName("i").length == 1);
        return isIeLessThan9;
    }

    isFirefox() {
        return typeof InstallTrigger !== 'undefined';
    }

    isMobile() {
        var mobile = false;
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf("ipad") != -1 || ua.indexOf("iphone") != -1 || ua.indexOf("android") != -1 || ua.indexOf("ipod") != -1 || ua.indexOf("windows ce") != -1 || ua.indexOf("windows phone") != -1) {
            mobile = true;
        }

        return mobile;

    }

    hasFlash() {
        return function (a, b) { try { a = new ActiveXObject(a + b + '.' + a + b) } catch (e) { a = navigator.plugins[a + ' ' + b] } return !!a }('Shockwave', 'Flash');
    }

    getFlashVarsString() {
        var flashVarsString;
        if (this.flashvars && typeof this.flashvars === "object") {
            for (var k in this.flashvars) {
                if (typeof flashVarsString != "undefined") {
                    flashVarsString += "&" + k + "=" + this.flashvars[k];
                }
                else {
                    flashVarsString = k + "=" + this.flashvars[k];
                }
            }
        }

        //console.log(flashVarsString);
        flashVarsString = flashVarsString.replace(/\"/g, '\&quot;');
        this.reportLogMessage({msg: "HDFVR: flash vars:" + flashVarsString});
        //console.log(flashVarsString);

        return flashVarsString;

    }



    //HDFVR Callbacks
    onRecorderInit(recorderId){
		this.reportLogMessage({msg: "HDFVR: onRecorderInit("+recorderId+")"});
		//Triggers after the initial [Record Video] screen is drawn. After this function is called you can safely call document.VideoRecorder.startRecorder(). If skipInitialScreen is turned on in avc_settings.xxx this function is not called. Added in HDFVR 2.2.
		document.VideoRecorder.startRecorder();
	}

    userHasCamMic(cam_number, mic_number, recorderId) {
        this.reportLogMessage({msg:"HDFVR: userHasCamMic(" + cam_number + "," + mic_number + "," + recorderId + ")"});
        //this function is called when HDFVR is initialized
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page
    }



    onUploadDone(streamName, streamDuration, userId, recorderId, audioCodec, videoCodec, fileType) {
        var args = Array.prototype.slice.call(arguments);
        this.reportLogMessage({msg: "HDFVR: onUploadDone(" + args.join(",") + ")"});

        //this function is called when the video/audio stream has been all sent to the media server and has been saved to the video server HHD, 
        //on slow client->server connections, because the data can not reach the media server in real time, it is stored in the recorder's buffer until it is sent to the server, you can configure the buffer size in avc_settings.XXX

        //this function is called with 7 parameters: 
        //streamName: a string representing the name of the stream recorded on the video server WITHOUT the filename extension (.flv , .f4v or .mp4)
        //userId: the userId sent via flash vars or via the avc_settings.XXX file, the value in the avc_settings.XXX file takes precedence if its not empty
        //duration of the recorded video/audio file in seconds but acccurate to the millisecond (like this: 4.322)
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page
        //audioCodec: the audio codec used for the recording, Nelly Moser or Speex
        //videoCodec: the video codec used for the recording, Sorenson or H.264
        //fileType: the format in which the resulting recording will be saved in: FLV, F4V or MP4
        if(this.timeReportTimer) {
            clearTimeout(this.timeReportTimer);
            this.timeReportTimer = null;
        }
        this.recordingComplete();
    }





    onSaveOk(streamName, streamDuration, userId, cameraName, micName, recorderId, audioCodec, videoCodec, fileType, videoId) {
        var args = Array.prototype.slice.call(arguments);
        this.reportLogMessage({msg: "HDFVR: onSaveOk(" + args.join(",") + ")"});

        this.saveComplete({filename: streamName + '.' + fileType});

         //the user pressed the [save] button inside the recorder and the save_video_to_db.XXX script returned save=ok
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page
        //audioCodec: the audio codec used for the recording, Nelly Moser or Speex
        //videoCodec: the video codec used for the recording, Sorenson or H.264
        //fileType: the format in which the resulting recording will be saved in: FLV, F4V or MP4
        //videoId: the videoId sent via flash vars
    }

    onSaveFailed(streamName, streamDuration, userId, recorderId) {
        this.reportLogMessage({msg: "HDFVR: onSaveFailed(" + streamName + "," + streamDuration + "," + userId + "," + recorderId + ")"});
        this.reportError({msg: "Error while saving video.  Please contact site administrator"});

        //the user pressed the [save] button inside the recorder but the save_video_to_db.XXX script returned save=fail
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page
    }


    onRecorderReady(recorderId) {
        this.reportLogMessage({msg: "HDFVR: onRecorderReady(" + recorderId + ")"});
        //HDFVR has moved past the initial screen, privacy screen and device selection screen and has reached the recording UI. You can now trigger the recording process using document.VideoRecorder.record().
        //Example : document.VideoRecorder.record(); will make a call to flash in order to start recording
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page

        this.recorderReady();
    }

    onPlaybackComplete(recorderId) {
        this.reportLogMessage({msg: "HDFVR: onPlaybackComplete(" + recorderId + ")"});
        //this function is called when HDFVR plays back a recorded video and the playback completes
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page
        this.bufferMsg.hidden = true;
        this.lastPlaybackTime = null;
        this.playbackComplete();

    }

    onRecordingStarted(recorderId) {
        this.reportLogMessage({msg: "HDFVR: onRecordingStarted(" + recorderId + ")"})
        //this function is called when HDFVR starts recording
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page

       this.recordingStarted();

    }

    onCamAccess(allowed, recorderId) {
        this.reportLogMessage({msg: "HDFVR: onCamAccess(" + allowed + "," + recorderId + ")"});
        //the user clicked Allow or Deny in the Camera/Mic access dialog box in Flash Player
        //when the user clicks Deny this function is called with allowed=false
        //when the user clicks Allow this function is called with allowed=true
        //this function can be called anytime during the life of the HDFVR instance as the user has permanent access to the Camera/Mic access dialog box in Flash Player
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page

        if(!allowed) {
            this.reportError({msg: "Unable to record video.  Access to Camera/Mic was denied.  Please refresh the page and select 'Allow' when prompted."})
        }

    }

    onFPSChange(recorderId, currentFPS) {
        //this.reportLogMessage({msg: "HDFVR: onFPSChange("+recorderId+","+currentFPS+")"});
        //this function is called by HDFVR every second
        //currentFPS:the current frames-per-second that HDFVR reports (during recording, playback, uploading and saving) depending of the state of HDFVR.
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page
    }

    onConnectionClosed(recorderId) {
        this.reportLogMessage({msg: "HDFVR: nConnectionClosed(" + recorderId + ")"});
        //this function is called by HDFVR when the connection to the media server has been lost
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page
    }

    onConnectionStatus(status, recorderId) {
        this.reportLogMessage({msg: "HDFVR: onConnectionStatus(" + status + "," + recorderId + ")"});
        //this function is called by HDFVR for every connection event.
        //status: the actual connection status: (connected, rejected, invalid app, closed, failed)
        //recorderId: the recorderId sent via flash vars, to be used when there are many recorders on the same web page
    }




}